import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};
const actions = {
  downloadInboundOrderTemplate(_, url) {
    return axios
      .get(url, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  downloadSkuBBTemplate(_, url) {
    return axios
      .get(url, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  downloadOutoundOrderTemplate(_, url) {
    return axios
      .get(url, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  downloadInboundOrderItem(_, id) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inbound_download/${id}`, {
        responseType: "blob",
      })

      .then((res) => res);
  },

  downloadInboundASN(_, id) {
    return axios
      .get(`/api/fulfillmentbb/b2b_inbound/grr_closure/download/${id}`, {
        responseType: "blob",
      })

      .then((res) => res);
  },

  downloadOutboundASN(_, id) {
    return axios
      .get(`/api/fulfillmentbb/b2b_outbound/dn_closure/download/${id}`, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  downloadOutboundOrderItem(_, id) {
    return axios
      .get(`/api/fulfillmentbb/b2b_outbound_download/${id}`, {
        responseType: "blob",
      })

      .then((res) => res);
  },
  getInboundOrderBBList(_, payload) {
    return axios
      .get(`api/fulfillmentbb/inbound/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getInboundOrderBBSummaryList(_, payload) {
    return axios
      .get(`api/fulfillmentbb/inbound_report_summary_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getInboundGooodsSummary(_, payload) {
    return axios
      .get(`api/fulfillmentbb/b2b_inbound_received_good_expiry_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  addGoodsComment(_, payload) {
    return axios
      .patch(
        `/api/fulfillmentbb/b2b_inbound_received_good_expiry_update/${payload.id}`,
        payload.data
      )
      .then((res) => res.data);
  },
  getSKUB2BList(_, payload) {
    return axios
      .get(`api/btb_sku_uploaded_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getB2bSKUList(_, payload) {
    return axios.post(`api/btb_sku_list`, payload).then((res) => res.data);
  },
  getOutboundOrderBBList(_, payload) {
    return axios
      .get(`api/fulfillmentbb/outbound/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadb2bskulist(_, payload) {
    return axios
      .post(`/api/btb_sku_list_download`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  inboundorderSummary(context, payload) {
    return axios
      .get(`/api/fulfillmentbb/inbound/itemlist/${payload.id}`, {
        params: payload,
      })

      .then((res) => res);
  },
  inboundStatus(_, type) {
    return axios
      .get(`/api/fulfillmentbb/b2b_dropdown?status_type=${type}`)

      .then((res) => res);
  },
  outboundorderSummary(context, id) {
    return axios
      .get(`/api/fulfillmentbb/outbound/itemlist/${id}`)

      .then((res) => res);
  },
  uploadinboundList(_, payload) {
    return axios
      .post(`api/fulfillmentbb/inbound/upload`, payload)
      .then((res) => res.data);
  },
  updateinboundList(_, payload) {
    return axios
      .post(`api/fulfillmentbb/inbound_add_edit_lines`, payload)
      .then((res) => res.data);
  },
  uploadBulkinboundList(_, payload) {
    return axios
      .post(`api/fulfillmentbb/inbound/bulk_upload`, payload)
      .then((res) => res.data);
  },
  uploadb2bskuList(_, payload) {
    return axios.post(`api/btb_sku_upload`, payload).then((res) => res.data);
  },
  uploadoutboundList(_, payload) {
    return axios
      .post(`api/fulfillmentbb/outbound/upload`, payload)
      .then((res) => res.data);
  },
  updateOutboundList(_, payload) {
    return axios
      .post(`api/fulfillmentbb/outbound_add_edit_lines`, payload)
      .then((res) => res.data);
  },
  uploadoutboundBulkList(_, payload) {
    return axios
      .post(`api/fulfillmentbb/outbound/bulk_upload`, payload)
      .then((res) => res.data);
  },
  getInboundSettings(_, id) {
    return axios
      .get(
        `/api/fulfillment/outbound_order_template?b2b_fulfillment=inbound&client_id=${id}`
      )
      .then((res) => res.data);
  },
  getDetailInbound(_, id) {
    return axios
      .get(`/api/fulfillmentbb/inbound_get_order_details/${id}`)
      .then((res) => res.data);
  },
  getDetailOutbound(_, id) {
    return axios
      .get(`/api/fulfillmentbb/outbound_get_order_details/${id}`)
      .then((res) => res.data);
  },
  getInboundBulkSettings(_, id) {
    return axios
      .get(
        `/api/fulfillment/outbound_order_template?b2b_fulfillment=bulk_inbound&client_id=${id}`
      )
      .then((res) => res.data);
  },
  getOutboundSettings(_, payload) {
    return axios
      .get(
        `/api/fulfillment/outbound_order_template?b2b_fulfillment=outbound&client_id=${payload.client_id}&allocation_filter=${payload.allocation_filter}`
      )
      .then((res) => res.data);
  },
  getOutboundBulkSettings(_, payload) {
    return axios
      .get(
        `/api/fulfillment/outbound_order_template?b2b_fulfillment=bulk_outbound&client_id=${payload.client_id}&allocation_filter=${payload.allocation_filter}`
      )
      .then((res) => res.data);
  },
  getSupplierVisibility(_, payload) {
    return axios.post(
      `/api/fulfillmentbb/b2b_supplier_mapping_dropdown`,
      payload
    );
  },
  getFianceList(_, payload) {
    return axios
      .get(`api/finance_data/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
